const merge = (t, s) => {
  const o = Object,
    a = o.assign;
  for (const k of o.keys(s)) s[k] instanceof o && a(s[k], merge(t[k], s[k]));
  return a(t || {}, s), t;
};

export default {
  createPrematchMatches({ commit }, result) {
    if (!result || !result.length) return;
    result.forEach(row => {
      commit("createPrematchMatch", {
        _id: row._id,
        match: row.data
      });
    });
  },
  deletePrematchMatches({ commit }, result) {
    if (!result || !result.length) return;
    result[0].forEach(_id => {
      commit("deletePrematchMatch", _id);
    });
  },
  fetchPrematchMatches({ commit }, matches) {
    commit("prematchMatches", matches);
  },
  updatePrematchMatches({ state, commit }, result) {
    if (!result || !result.length) return;
    result.forEach(row => {
      let match = state.prematch.matches.find(({ _id }) => row._id === _id);
      row.data.forEach(obj => {
        const { data, odds } = (({ odds, ...data }) => ({ odds, data }))(obj);

        if (data) {
          // eslint-disable-next-line fp/no-mutation
          match = merge(match, data);
          commit("updatePrematchMatch", { _id: row._id, match });
        }
        if (odds) {
          Object.keys(odds).forEach(keys => {
            const [part, type, key, param] = keys.split(".").slice(1);
            // eslint-disable-next-line fp/no-mutation
            match.odds[part][type][key][param] = odds[keys];
            commit("updatePrematchMatch", { _id: row._id, match });
          });
        }
      });
    });
  }
};
